import type { FC } from 'react';
// Asset imports - bundler handles path resolution
import warningIcon from '~/static/assets/icons/landing-page/warning-icon.svg';
import type { ModalFooterProps } from '../../types';

const ModalFooter: FC<ModalFooterProps> = ({ queryError, isFetching, onClose, leadingAction }) => {
  return (
    <div className="personal-meetings-modal__footer">
      {leadingAction && (
        <div className="personal-meetings-modal__footer-leading">{leadingAction}</div>
      )}
      {queryError && (
        <div className="personal-meetings-modal__status personal-meetings-modal__status--error">
          <img
            src={warningIcon.src}
            width={warningIcon.width}
            height={warningIcon.height}
            alt="Error"
          />
          {queryError.message}
        </div>
      )}
      {isFetching && (
        <div className="personal-meetings-modal__status personal-meetings-modal__status--loading">
          <span>Refreshing meetings…</span>
        </div>
      )}

      <div className="personal-meetings-modal__footer-actions">
        <button
          type="button"
          className="personal-meetings-modal__footer-button personal-meetings-modal__footer-button--close"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ModalFooter;
